import { render } from "./ValueRoadMapSetup.vue?vue&type=template&id=6e28ca23"
import script from "./ValueRoadMapSetup.vue?vue&type=script&lang=js"
export * from "./ValueRoadMapSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__